// extracted by mini-css-extract-plugin
export default {"contentContainer":"CpaDrawing_contentContainer__6QrHV","loading":"CpaDrawing_loading__1TZ+8"};